import { FC } from 'react';
import Input from '~/view/components/Controls/InputComponent/Input';
import { localeStore } from '~/mobx/localesStore';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';

interface IProps {
  title: string;
  value: string;
  onChange: (value: string | undefined) => void;
}

const ApplePayInput: FC<IProps> = ({ title, value, onChange }): JSX.Element => {
  return (
    <div className="mt-5">
      <Text type={TEXT.BLOCK_HEADER} text={localeStore.t(title)} />
      <Input value={value} onChangeValue={onChange} className="mt-2" contentClassName="apple-pay-input__input" />
    </div>
  );
};

export default ApplePayInput;
